import React from 'react';
import { FormattedMessage } from "react-intl";
import CONSTANTS from "../utils/constants";
import { Container } from 'react-bootstrap';

const NotFound: React.FC = () => {

  return (
    <Container className="notfound-container d-flex flex-column text-center my-5 rounded justify-content-center">
      <h1 className="mb-0 page-title" data-testid="notFoundPage-status-code">
        <FormattedMessage id={CONSTANTS.NOT_FOUND_PAGE.STATUS_CODE} defaultMessage="404" />
      </h1>
      <h2 className="display-6 mb-3" data-testid="notFoundPage-message-header">
        <FormattedMessage id={CONSTANTS.NOT_FOUND_PAGE.STATUS_MESSAGE[0]} defaultMessage="Page Not Found" />
      </h2>
      <p className="lead mb-5" data-testid="notFoundPage-message-body">
        <FormattedMessage id={CONSTANTS.NOT_FOUND_PAGE.STATUS_MESSAGE[1]} defaultMessage="We can't find the page you're looking for." />
      </p>
    </Container>
  );
}

export default NotFound;